import styled from 'styled-components'

export const BellContainer = styled.div`
  width: 100%;
  height: 465px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Bell = styled.img`
  width: 290px;
`
